import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Modal, TextField, MenuItem, Snackbar, Alert } from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { Circles } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import AppLayout from "../Navbar/AppLayout";
import Footer from "../Navbar/Footer";
import { loadRequestData, postRaiseRequestData, approvedToReview, approvedToComplete, postShareRequestData, loadUploadUserwiseCsv, submitedResponseData, loadUploadCsvByCRM, loadUploadedContacts } from "../redux/action";
import { useNavigate, useLocation } from "react-router-dom";
import * as HeaderAuthentication from "../HeaderAuthentication";
import DownloadIcon from '@mui/icons-material/Download';
import { toast } from 'react-toastify';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const RaiseRequest = ({ hideLayout = false }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const { loading } = useSelector((state) => state.data);
  const location = useLocation();
  const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));
  const { requestData } = useSelector((state) => state.data);
  const userRole = signInDetails[0]?.role;
  const [currentRequestId, setCurrentRequestId] = useState(null);
  const [formDataModalOpen, setFormDataModalOpen] = useState(false);
  const [quoteDataModal, setquoteDataModal] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState("");
  const [updateModalOpen, setUpdateModalOpen] = useState(false);
  const [selectedRequestData, setSelectedRequestData] = useState(null);
  const [newRemark, setNewRemark] = useState("");
  const [open, setOpen] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [successOpen, setSuccessOpen] = useState(false);
  const [responseCount, setResponseCount] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const currentUserId = userRole?.id || 1;
  const [showShareModal, setShowShareModal, rowData] = useState(false);
  const [showSendEmailButton, setShowSendEmailButton] = useState(false);
  const [isResendMode, setIsResendMode] = useState(false);
  const [email, setEmail] = useState("");
  const [requestType, setRequestType] = useState("");
  const [count, setCount] = useState("");
  const [title, setTitle] = useState("");
  const [criteria, setCriteria] = useState("");
  const [remarks, setRemarks] = useState("");
  const [file, setFile] = useState(null);

  const [errors, setErrors] = useState({});



  const [formData, setFormData] = useState({
    companyName: signInDetails[0]?.company_name || "",
    userName: "",
    userEmail: "",
    requestType: "",
    criteria: "",
    counts: "",
    title: "",
    geography: "",
    remarks: "",
    // request_status:""
  });

  const [shareformData, setshareFormData] = useState({

    companyName: "",
    userName: "",
    userEmail: "",
    requestType: "",
    criteria: "",
    counts: "",
    title: "",
    geography: "",
    remarks: "",
    // request_status:""
  });




  const readOnlyStyle = {
    pointerEvents: "none",
    "& .MuiOutlinedInput-root": {
      "& fieldset": { borderColor: "#d1d1d1" },
      "&:hover fieldset": { borderColor: "#d1d1d1" },
      "&.Mui-focused fieldset": { borderColor: "#d1d1d1" }
    }
  };

  const currentPath = location.pathname.toLowerCase();
  const allowedPages = ["/raiserequest", "/sample", "/project"];
  const showShareButton =
    (userRole === "BDE" || userRole === "b2buser") &&
    allowedPages.some((p) => currentPath.includes(p));


  const handleSubmitResponse = async (requestId) => {
    if (!requestId) {
      alert("Request ID not found");
      return;
    }

    try {
      const formData = new FormData();

      // ORDS column names MUST match table column names
      formData.append("REQUEST_ID", requestId);
      formData.append("RESPONSE_COUNT", responseCount);
      formData.append("REMARKS", newRemark);

      // FILE UPLOAD (IMPORTANT)
      if (selectedFile) {
        formData.append("ATTACHMENT_FILE", selectedFile);   // actual file blob
        formData.append("FILE_NAME", selectedFile.name);     // varchar2 column
        formData.append("MIME_TYPE", selectedFile.type);     // mime column
      } else {
        // If no selected file, still send empty fields so ORDS won't treat as NULL
        formData.append("ATTACHMENT_FILE", new Blob());
        formData.append("FILE_NAME", "");
        formData.append("MIME_TYPE", "");
      }

      const response = await fetch(
        "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/Request/response_data",
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server Error:", errorText);
        alert("Failed to save data");
        return;
      }

      // SUCCESS
      console.log("Response saved!");
      setNewRemark("");
      setSelectedFile(null);
      setResponseCount("");

    } catch (error) {
      console.error("JS Error:", error);
    }
  };

  const handleDownload = async (row) => {
    if (!row.request_id && !row.response_id) {
      alert("Invalid request or response ID!");
      return;
    }

    const url =
      `https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge/download_requests/requests_download?` +
      `${row.response_id ? `response_id=${row.response_id}&` : ""}` +
      `${row.request_id ? `request_id=${row.request_id}` : ""}`;

    try {
      const res = await fetch(url);

      if (!res.ok) {
        const text = await res.text();
        console.error("Server error:", text);
        alert("Download failed!");
        return;
      }

      const blob = await res.blob();
      const contentType = res.headers.get("Content-Type") || "application/octet-stream";

      let filename = "Request_Details";
      const disposition = res.headers.get("Content-Disposition");

      if (disposition) {

        // 1️⃣ First check encoded filename*=
        const encodedMatch = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
        if (encodedMatch) {
          filename = decodeURIComponent(encodedMatch[1]);
        }

        // 2️⃣ Otherwise check filename=
        else {
          const normalMatch = disposition.match(/filename\s*=\s*"?([^"]+)"?/i);
          if (normalMatch) {
            filename = normalMatch[1].split(";")[0]; // Clean extra segments
          }
        }
      }

      const downloadUrl = window.URL.createObjectURL(
        new Blob([blob], { type: contentType })
      );

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename.trim();   // <-- EXACT original filename
      document.body.appendChild(a);
      a.click();
      a.remove();

      window.URL.revokeObjectURL(downloadUrl);

    } catch (error) {
      console.error("Download error:", error);
      alert("An error occurred during download.");
    }
  };
  const handleResend = async (row) => {
    // Open modal
    setShowShareModal(true);
    setShowSendEmailButton(true);

    // Fill data into form
    setshareFormData({
      userName: row.user_name,
      userEmail: row.user_email,
      companyName: row.company_name,
      requestType: row.request_type,
      counts: row.count,
      criteria: row.criteria,
      title: row.title,
      geography: row.geography,
      remarks: row.remarks,
      request_status: row.request_status,
    });

    // Enable view mode
    setIsViewMode(true);

    // Enable resend mode to unlock only email
    setIsResendMode(true);
  };

  const uploadAttachment = (file, requestId, requestFor) => {


    if (file == null) {
      toast.error("Please select the file");
      return;
    }
    const formData = new FormData();

    // ORDS column names MUST match table column names
    formData.append("REQUEST_ID", requestId);
    formData.append("RESPONSE_COUNT", responseCount);
    formData.append("REMARKS", newRemark);

    // FILE UPLOAD (IMPORTANT)
    if (file) {
      formData.append("ATTACHMENT_FILE", file);   // actual file blob
      formData.append("FILE_NAME", file.name);     // varchar2 column
      formData.append("MIME_TYPE", file.type);     // mime column
    } else {
      // If no selected file, still send empty fields so ORDS won't treat as NULL
      formData.append("ATTACHMENT_FILE", new Blob());
      formData.append("FILE_NAME", "");
      formData.append("MIME_TYPE", "");
    }
    const requestOption = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postAuthForFile,
      // body: file,
      body: new Blob([file], { type: "text/csv" }),
    };
    dispatch(loadUploadCsvByCRM(requestOption, formData, requestId, requestFor))

  }


  const [emailSentSuccess, setEmailSentSuccess] = useState(false);

  const handleSendEmail = async () => {
    try {
      const baseURL = "https://gfcb8ed8eb8355a-st94sy8hnd7n7e0g.adb.ap-mumbai-1.oraclecloudapps.com/ords/leadmerge";

      const res = await fetch(`${baseURL}/Share_Request/send_email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(shareformData),
      });

      const result = await res.json();

      if (result.status === 200) {
        // Show success message
        setEmailSentSuccess(true);

        // Auto-close modal after 1.5 seconds
        setTimeout(() => {
          setEmailSentSuccess(false);
          setShowShareModal(false);
        }, 1500);
      } else {
        console.error("Email failed:", result);
        // Optionally, show an error inside modal
        alert("Email Failed"); // Or you can handle with a state message
      }
    } catch (err) {
      console.error("Email error:", err);
      // Optionally, show an error inside modal
      alert("Error Sending Email"); // Or handle with a state message
    }
  };


  //  const role = userRole?.toLowerCase();

  // const isClient =
  //   role === "client" ||
  //   role === "client login" ||
  //   role === "client user" ||
  //   role.includes("client");

  const filteredData = (requestData || [])
    .filter((item) => {
      const type = item.request_type?.toLowerCase();

      if (currentPath.includes("/report")) {
        return type === "report";
      } else if (currentPath.includes("/sample")) {
        return (
          type === "count" ||
          type === "sample" ||
          type === "count and sample"
        );
      }
      return true;
    })

    .filter((item) => {
      if (userRole?.toLowerCase() === "b2buser") {
        const status = (item.request_status || "").toLowerCase().trim();
        return ["request sent", "reviewed", "completed"].includes(status);
      }
      return true;
    })

    .map((item) => {
      const status = item.request_status?.toLowerCase();

      const color =
        status === "reviewed"
          ? "#17A2B8"
          : status === "requested"
            ? "#6c757d"
            : status === "request sent"
              ? "#28a745"
              : status === "completed"
                ? "#0d6efd"
                : status === "rejected"
                  ? "#dc3545"
                  : "#6c757d";

      return {
        ...item,
        statusColor: color,
      };
    });

  const [quoteForm, setQuoteForm] = useState({
    counts: "",
    amount: ""
  });

const uniqueData = filteredData.filter(
  (row, index, self) =>
    index === self.findIndex((r) => r.request_id === row.request_id)
);

  // 🔧 ADD HERE
  const handleView = (row) => {
    console.log("View clicked:", row);
  };

  const handleUpdate = (row) => {
    console.log("Update clicked:", row);
  };

  const [isViewMode, setIsViewMode] = useState(false);
  const updatedStatus = "reviewed";

  const isBde = userRole?.toLowerCase() === "bde";
  const isClient = userRole?.toLowerCase() === "client";
  const isDashboard = currentPath.includes("/dashboard");
  const formatDate = (str) => {
    if (!str) return "";
    const parts = str.split("-");
    if (parts.length === 3) {
      return `${parts[0]}-${parts[1]}-${parts[2]}`;
    }
    return str;
  };

  const handleOpenShareModal = async (request = null) => {
    // Always reset form first
    setIsViewMode(false); // Editable mode
    setshareFormData({
      userName: "",
      userEmail: "",
      companyName: "",
      requestType: "",
      counts: "",
      criteria: "",
      title: "",
      geography: "",
      remarks: "",
      fileUpload: null,
      file_name: "",
      request_status: "",
      createdbyemail: "",
      // request_for: ""
    });
    setShowSendEmailButton(false);

    if (!request) {
      // No request passed → New Share Request
      setShowShareModal(true);
      return;
    }

    // Existing request → fetch data and show in view mode
    try {
      const res = await fetch(
        `https://.../Request/${request.request_id}`
      );
      const data = await res.json();

      setIsViewMode(true); // Read-only

      setshareFormData({
        userName: data.user_name || "",
        userEmail: data.user_email || "",
        companyName: data.company_name || "",
        requestType: data.request_type || "",
        counts: data.counts || "",
        criteria: data.criteria || "",
        title: data.title || "",
        geography: data.geography || "",
        remarks: data.remarks || "",
        fileUpload: null,
        file_name: data.file_name || "",
        request_status: data.request_status || "",
        createdbyemail: data.createdbyemail || "",
        // request_for: data.request_for || "",
      });

      // const createdByLoggedUser =
      //   data.createdbyemail?.toLowerCase() ===
      //   signInDetails?.[0]?.email?.toLowerCase();
      // const isCompleted = data.request_status?.toLowerCase() === "completed";
      // // const isCompleted = data.request_status?.toLowerCase() === "request sent";

      // setShowSendEmailButton(createdByLoggedUser && isCompleted);

      // setShowShareModal(true);

      const createdByLoggedUser =
        data.createdbyemail?.toLowerCase() ===
        signInDetails?.[0]?.email?.toLowerCase();

      // Show send email if status is completed OR requested
      const status = data.request_status?.toLowerCase();

      const showEmail =
        createdByLoggedUser &&
        (status === "completed");

      setShowSendEmailButton(showEmail);

      setShowShareModal(true);
    } catch (err) {
      console.error("Error fetching request data:", err);
      alert("Failed to open Share Modal");
    }
  };
   let columns = [

    {
      field: "slno",
      headerName: "Sl.No",
      
      sortable: false,
      filterable: false,
      renderCell: (params) => params.api.getRowIndexRelativeToVisibleRows(params.id) + 1,
    },
    { field: "request_id", headerName: "Request ID" },
     ...(userRole === "BDE"
    ? [
        { field: "user_name", headerName: "Name",},
        { field: "company_name", headerName: "Company Nmae", },
        { field: "user_email", headerName: "Email", },
        
      ]
    : []),
    { field: "request_type", headerName: "Request Type", },
    { field: "criteria", headerName: "Criteria", },
    { field: "title", headerName: "Title", },
    { field: "geography", headerName: "Geography", },
    
    { field: "response_count", headerName: "Response Count", },
    { field: "response_remark", headerName: "Remarks", },

    {
      field: "created_date",
      headerName: "Created Date",
      
      renderCell: (params) => {
        if (!params.value) return "";
        const date = new Date(params.value);

        const day = String(date.getDate()).padStart(2, "0");
        const month = date.toLocaleString("en-GB", { month: "short" });
        const year = date.getFullYear();

        return (
          <Typography style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
            {`${day}-${month}-${year}`} {/* Output: 20-Nov-2025 */}
          </Typography>
        );
      },
    },
    // { field: "count", headerName: "Count" ,width: 80},
    {
      field: "request_status",
      headerName: "Status",
      
      renderCell: (params) => {
        const status = (params.row.request_status || "").toLowerCase();
        const color =
          status === "reviewed"
            ? "#17A2B8"
            : status === "request sent"
              ? "#28a745"
              : status === "completed"
                ? "#0d6efd"
                : status === "rejected"
                  ? "#dc3545"
                  : "#6c757d";

        return <span style={{ color, fontWeight: 600 }}>{params.row.request_status}</span>;
      },
    },

    ...(!["client"].includes(userRole?.toLowerCase())
      ? [
        {
          field: "approve",
          headerName: "Action",
          


          renderCell: (params) => {
            const role = (userRole || "").toLowerCase();
            const status = (params.row.request_status || "").toLowerCase();
            const hasFile = !!params.row.file_name;

            const hideUpdateForBDE = role === "bde" && params.row.userName && params.row.userEmail;

            const hideUpdateForClient = role === "client";

            const hideUpdate = hideUpdateForBDE || hideUpdateForClient;

            const disableB2BUpdate = role === "b2buser" && hasFile;

            // const isDisabled =
            //   status === "completed" || 
            //   status === "requested" ||
            //   status === "request sent" ||
            //   (status === "reviewed" && role !== "b2buser") ||
            //   disableB2BUpdate;

            const isDisabled =
              status === "completed" ||
              status === "request sent" ||
              (status === "requested" && role !== "b2buser") || // ❗ Only disable for non-B2B
              (status === "reviewed" && role !== "b2buser") ||
              disableB2BUpdate;

            return (
              <>

                
                {/* {!hideUpdate && status !== "request sent" && status !== "completed" && ( */}
                {!hideUpdate && status !== "completed" && (
                  <span
                    onClick={() => {
                      if (isDisabled) return;

                      if (role === "bde") {
                        setCurrentRequestId(params.row.request_id);
                        setUpdateModalOpen(true);
                        return;
                      }

                      if (role === "b2buser") {
                        const hasShareData = params.row.userName && params.row.userEmail;

                        if (hasShareData) {
                          setFormData({
                            userName: params.row.user_name,
                            userEmail: params.row.user_email,
                            requestType: params.row.request_type,
                            counts: params.row.count,
                            criteria: params.row.criteria,
                            title: params.row.title,
                            geography: params.row.geography,
                            remarks: params.row.remarks,
                            fileUpload: null,
                            file_name: params.row.file_name || null
                          });
                          setShowShareModal(true);
                        } else {
                          setSelectedRequestData(params.row);
                          setFormDataModalOpen(true);
                        }
                        return;
                      }

                      // CLIENT NOW DOES NOT SEE UPDATE (so no handler needed)
                    }}
                    style={{
                      color: "#ffffff",
                      background: isDisabled ? "#adb5bd" : "#0d6efd",
                      padding: "7px",
                      borderRadius: "5px",
                      cursor: isDisabled ? "not-allowed" : "pointer",
                      fontWeight: 500,
                      opacity: isDisabled ? 0.6 : 1,
                      pointerEvents: isDisabled ? "none" : "auto",
                      marginRight: "8px",
                    }}
                  >
                    Update
                  </span>
                )} 

                {userRole === "BDE" &&
                  params.row.createdbyemail?.toLowerCase() ===
                  signInDetails?.[0]?.email?.toLowerCase() &&
                  params.row.request_status?.toLowerCase() === "completed" && (
                    <span
                      onClick={() => {
                        setIsViewMode(true);

                        setshareFormData({
                          userName: params.row.user_name || "",
                          userEmail: params.row.user_email || "",
                          companyName: params.row.company_name || "",
                          requestType: params.row.request_type || "",
                          counts: params.row.count || "",
                          criteria: params.row.criteria || "",
                          title: params.row.title || "",
                          geography: params.row.geography || "",
                          remarks: params.row.remarks || "",
                          fileUpload: null,
                          file_name: params.row.file_name || "",
                          request_status: params.row.request_status || "",
                          createdbyemail: params.row.createdbyemail || "",
                        });

                        setShowShareModal(true);

                        setShowSendEmailButton(
                          ["completed", "request sent"].includes(
                            params.row.request_status?.toLowerCase()
                          )
                        );
                      }}
                      style={{
                        color: "#0d6efd",
                        background: "#e7f1ff",
                        padding: "7px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: 500,
                      }}
                    >
                      View
                    </span>
                  )}


                {userRole === "BDE" &&
                  params.row.createdbyemail?.toLowerCase() ===
                  signInDetails?.[0]?.email?.toLowerCase() &&
                  params.row.request_status?.toLowerCase() === "request sent" && (
                    <span
                      onClick={() => {
                        // Your resend function here
                        handleResend(params.row);
                      }}
                      style={{
                        color: "#d63384",
                        background: "#ffe2f0",
                        padding: "7px",
                        borderRadius: "5px",
                        cursor: "pointer",
                        fontWeight: 500,

                      }}
                    >
                      Resend
                    </span>
                  )}

              </>
            );
          }

        }
      ]
      : []
    ),


    ...(userRole?.toLowerCase() !== "client"
      ? [
        {
          field: "file_name",
          headerName: "Download",
          
          sortable: false,
          renderCell: (params) => {
            const row = params.row;
            const status = (row.request_status || "").toLowerCase();
            const isDisabled = !(status === "completed" || status === "request sent");

            return (
              <span
                onClick={() => !isDisabled && handleDownload(row)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                  color: isDisabled ? "#9e9e9e" : "#0d6efd",
                  cursor: isDisabled ? "not-allowed" : "pointer",
                  opacity: isDisabled ? 0.6 : 1,
                  pointerEvents: isDisabled ? "none" : "auto",
                }}
              >
                <DownloadIcon fontSize="small" />
                Download
              </span>
            );
          },
        },
      ]
      : []),

    ...(
      ((isBde && isDashboard) || isClient)
        ? [
          {
            field: "payment",
            headerName: isBde ? "Quote" : "Payment",
            

            renderCell: (params) => {
              const row = params.row;
              const status = (row.request_status || "").toLowerCase();
              const requestType = (row.request_type || "").toLowerCase();

              let isDisabled = false;

              if (isBde) {
                isDisabled = status === "completed" || status === "reviewed";
              }

              // Client rules
              if (isClient) {
                // ❗ Only show "Make Payment" when request_type = project
                if (requestType !== "project") return null;

                isDisabled = status !== "completed";
              }

              const label = isBde ? "Quote" : "Make Payment";

              return (
                <span
                  onClick={() => {
                    if (isDisabled) return;

                    setSelectedRequestData(row);

                    if (isBde) {
                      setquoteDataModal(true);
                    } else if (isClient) {
                      navigate("/raiserequest", {
                        state: { request_id: row.request_id }
                      });
                    }
                  }}
                  style={{
                    color: isDisabled ? "#6c757d" : "#0d6efd",
                    fontWeight: 500,
                    cursor: isDisabled ? "not-allowed" : "pointer",
                    opacity: isDisabled ? 0.5 : 1,
                    pointerEvents: isDisabled ? "none" : "auto",
                  }}
                >
                  {label}
                </span>
              );
            }
          }
        ]
        : []
    )

  ];
const mrtColumns = columns.map((col) => ({
  accessorKey: col.field,
  header: col.headerName,
  size: col.width || 150,

  Cell: col.renderCell
    ? ({ row }) =>
        col.renderCell({
          row: row.original,
          value: row.original[col.field],
          id: row.id,
          api: {
            getRowIndexRelativeToVisibleRows: () => row.index,
          },
        })
    : undefined,
}));

  
  const isBdeDashboard =
    userRole?.toLowerCase() === "bde" && currentPath.includes("/dashboard");

 

  if (isBdeDashboard) {
    columns = columns.filter(
      (col) =>
        !["criteria", "geography", "remarks", "created_date"].includes(
          col.field
        )
    );
  }

  if (isDashboard) {
    const hideFields = ["count", "criteria", "geography", "remarks", "created_date"];
    columns = columns.filter((col) => !hideFields.includes(col.field));
  }

  // useEffect(() => {
  //   dispatch(loadRequestData(""));
  // }, [dispatch]);

useEffect(() => {
  setIsLoading(true);
  dispatch(loadRequestData());
}, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Update formData
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    // Update shareFormData
    setshareFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };




  const shareHandleSubmit = async (e) => {
    e.preventDefault();

    // Base payload
    let payload = {

      company_name: shareformData.companyName,
      user_email: shareformData.userEmail,
      user_name: shareformData.userName,
      request_type: shareformData.requestType,
      count: shareformData.counts,
      criteria: shareformData.criteria,
      title: shareformData.title,
      geography: shareformData.geography,
      remarks: shareformData.remarks,
      createdby: parseInt(signInDetails[0]?.id),
      createdbyemail: signInDetails[0]?.email,
      sbnid: signInDetails[0]?.sbn_id,
      // request_for: parseInt(signInDetails[0]?.id),
    };


    // 🔥 Hide or override data for client role
    if (userRole === "client") {
      payload = {
        request_type: shareformData.requestType,
        remarks: shareformData.remarks,
        // only fields client is allowed to send
      };
    }

    const requestOption = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postAuthOfLeadMerge,
      body: JSON.stringify(payload),
    };

    try {
      const res = await dispatch(postRaiseRequestData(requestOption));

      if (res?.status === 200) {
        setSuccessOpen(true);
        setOpen(false);
        setShowShareModal(false);
        setIsViewMode(false);
      }
    } catch (error) {
      console.error("Error submitting request:", error);
    }

  };
  console.log(signInDetails, "signInDetails");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      company_name: formData.companyName,

      request_type: formData.requestType,
      count: formData.counts,
      criteria: formData.criteria,
      title: formData.title,
      geography: formData.geography,
      remarks: formData.remarks,
      createdby: parseInt(signInDetails[0]?.id),
      createdbyemail: signInDetails[0]?.email,
      sbnid: signInDetails[0]?.sbn_id,
      // request_for: parseInt(signInDetails[0]?.id),

    };

    const requestOption = {
      method: "POST",
      mode: "cors",
      headers: HeaderAuthentication.postAuthOfLeadMerge,
      body: JSON.stringify(payload),
    };

    try {

      const res = await dispatch(postRaiseRequestData(requestOption));
      if (res?.status === 200) {
        setSuccessOpen(true);
        setOpen(false);
        setShowShareModal(false);
        setIsViewMode(false);
      }
    } catch (error) {
      console.error("Error submitting request:", error);
    }
  };

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 550,
    bgcolor: "background.paper",
    p: 3,
    borderRadius: 2,
    boxShadow: 24,
  };

  const content = (
    <div className="page-layout">
      <div className="page-content raiseRequestPage" >
        <Box sx={{ p: 2 }}>


          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Typography variant="h5">
              {currentPath.includes("/report")
                ? "Report Requests"
                : currentPath.includes("/sample")
                  ? "Sample / Count Requests"
                  : "Raise Request"}
            </Typography>

            {/** CLIENT USER → show + Request */}
            {userRole === "Client" && (
              <Button
                variant="contained"
                onClick={() => setOpen(true)}
                style={{
                  color: "#fff",
                  fontWeight: 500,
                  background: "#0d6efd",
                  padding: "7px",
                  borderRadius: "5px",
                }}
              >
                + Request
              </Button>
            )}

            {/** BDE USER → show Share Request */}
            {userRole === "BDE" && showShareButton && (
              <Button
                variant="contained"
                // onClick={() => setShowShareModal(true)}
                onClick={() => handleOpenShareModal(null)}
                style={{
                  fontWeight: 500,
                  borderColor: "#0d6efd",
                  color: "#fff",
                  padding: "7px",
                  borderRadius: "5px",
                }}
              >
                Share Request
              </Button>
            )}

            {userRole?.toLowerCase() === "b2buser" && (
              <Button
                variant="outlined"
                component="a"
                href="/Format/Format.csv"  // ⚡ replace with your file path
                download
                style={{
                  fontWeight: 500,
                  borderColor: "#0d6efd",
                  color: "#0d6efd",
                  padding: "7px",
                  borderRadius: "5px",
                }}
              >
                Sample Format
              </Button>
            )}

          </Box>                   
  
<MaterialReactTable
  columns={mrtColumns}
  data={loading ? [] : uniqueData.slice().sort((a, b) => a.request_id - b.request_id)}
  getRowId={(row) => row.request_id}

  enablePagination={false}
  enableColumnResizing
  enableStickyHeader
  enableDensityToggle={false}

  state={{
    isLoading: loading, // ✅ redux-controlled
  }}

  renderEmptyRowsFallback={() => (
    <Box
      sx={{
        height: "300px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Circles height="40" width="40" color="#1976d2" />
    </Box>
  )}

  muiTableContainerProps={{
    sx: {
      height: isDashboard ? "100%" : "calc(100vh - 320px)",
      maxHeight: isDashboard ? "100%" : "calc(100vh - 320px)",
      overflowY: "auto",
      overflowX: "auto",
    },
  }}
/>




        </Box>

        {/* Modal */}
        <Modal open={open} onClose={() => setOpen(false)} className="requestModal">
          <Box component="form" onSubmit={handleSubmit} sx={modalStyle}>
            <Typography variant="h6" mb={3}>
              Raise New Request
            </Typography>

            <div className="row g-3">
              <div className="col-md-6">
                <TextField
                  select
                  fullWidth
                  label="Request Type"
                  name="requestType"
                  value={formData.requestType}
                  onChange={handleChange}
                  required
                >
                  <MenuItem value="project">Project</MenuItem>
                  <MenuItem value="countS">Count</MenuItem>
                  <MenuItem value="sample">Sample</MenuItem>
                  <MenuItem value="count and sample">
                    Count and Sample
                  </MenuItem>
                </TextField>
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Criteria"
                  name="criteria"
                  value={formData.criteria}
                  onChange={handleChange}
                  required
                />
              </div>



              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-6">
                <TextField
                  fullWidth
                  label="Geography"
                  name="geography"
                  value={formData.geography}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="col-md-12">
                <TextField
                  fullWidth
                  multiline
                  rows={3}
                  label="Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                />
              </div>
            </div>

            <Box display="flex" justifyContent="flex-end" mt={4}>
              <Button variant="outlined" onClick={() => setOpen(false)} sx={{ mr: 2 }} style={{
                borderColor: "#0d6efd",
                color: "#0d6efd",
                marginTop: "10px"
              }}>Cancel</Button>
              <Button variant="contained" style={{
                backgroundColor: "#0d6efd",
                color: "#ffffff",
                marginTop: "10px"
              }} type="submit">Submit</Button>
            </Box>
          </Box>
        </Modal>
        {(userRole === "BDE" || userRole === "b2buser") && (
          <Modal open={showShareModal} onClose={() => setShowShareModal(false)} className="requestModal">

            <Box component="form" onSubmit={shareHandleSubmit} sx={modalStyle}>
              <Typography variant="h6" mb={3}>
                Share Request
              </Typography>

              <div className="row g-3">

                {/* Name */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Name"
                    name="userName"
                    value={shareformData.userName}
                    onChange={handleChange}
                    required
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Company Name"
                    name="companyName"
                    value={shareformData.companyName}
                    onChange={handleChange}
                    required
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

                {/* Email */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Email"
                    type="email"
                    name="userEmail"
                    value={shareformData.userEmail}
                    onChange={handleChange}
                    required
                    disabled={isViewMode && !isResendMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

                {/* Request Type */}
                <div className="col-md-6">
                  <TextField
                    select
                    fullWidth
                    label="Request Type"
                    name="requestType"
                    value={shareformData.requestType}
                    onChange={handleChange}
                    required
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  >
                    <MenuItem value="project">Project</MenuItem>
                    <MenuItem value="count">Count</MenuItem>
                    <MenuItem value="sample">Sample</MenuItem>
                    <MenuItem value="count and sample">Count and Sample</MenuItem>
                  </TextField>
                </div>

                {/* Counts */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Counts"
                    name="counts"
                    type="number"
                    value={shareformData.counts}
                    onChange={handleChange}
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

                {/* Criteria */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Criteria"
                    name="criteria"
                    value={shareformData.criteria}
                    onChange={handleChange}
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

                {/* Title */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Title"
                    name="title"
                    value={shareformData.title}
                    onChange={handleChange}
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

                {/* Geography */}
                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Geography"
                    name="geography"
                    value={shareformData.geography}
                    onChange={handleChange}
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>


                {userRole === "bde" && shareformData.request_status?.toLowerCase() === "completed" && (
                  <div className="col-md-12">
                    {shareformData.file_name && (
                      <Typography variant="body2" mt={1}>
                        Uploaded by B2B: {shareformData.file_name}
                      </Typography>
                    )}
                    <input
                      type="file"
                      onChange={(e) =>
                        setshareFormData({ ...shareformData, fileUpload: e.target.files[0] })
                      }
                      accept=".pdf,.doc,.docx,.xlsx,.csv,.jpg,.png"
                    />
                  </div>
                )}



                {/* Remarks */}
                <div className="col-md-12">
                  <TextField
                    fullWidth
                    multiline
                    rows={3}
                    label="Remarks"
                    name="remarks"
                    value={shareformData.remarks}
                    onChange={handleChange}
                    disabled={isViewMode}
                    sx={{
                      "& .MuiInputBase-input.Mui-disabled": {
                        WebkitTextFillColor: "#000000",   // Forces black text
                      }
                    }}
                  />
                </div>

              </div>
              {emailSentSuccess && (
                <Typography
                  variant="body1"
                  sx={{ color: "green", mb: 2, textAlign: "center" }}
                >
                  Email sent successfully!
                </Typography>
              )}

              <Box display="flex" justifyContent="flex-end" mt={4}>
                <Button
                  variant="outlined"
                  onClick={() => setShowShareModal(false)}
                  sx={{ mr: 2 }}
                  style={{ borderColor: "#0d6efd", color: "#0d6efd", marginTop: "10px" }}
                >
                  Cancel
                </Button>
                {showSendEmailButton && (
                  <Button
                    variant="contained"
                    onClick={() => handleSendEmail(shareformData)}
                    sx={{ mr: 2 }}
                    style={{ backgroundColor: "#28a745", color: "#ffffff", marginTop: "10px" }}
                  >
                    Send Email
                  </Button>
                )}

                {!isViewMode && (
                  <Button
                    variant="contained"
                    type="submit"
                    style={{ backgroundColor: "#0d6efd", color: "#ffffff", marginTop: "10px" }}
                  >
                    Submit
                  </Button>
                )}
              </Box>


            </Box>

          </Modal>
        )}


        <Modal open={updateModalOpen} onClose={() => setUpdateModalOpen(false)} className="requestModal">
          <Box sx={modalStyle} component="form" onSubmit={async (e) => {
            e.preventDefault();

            if (!approvalStatus) {
              alert("Select status first");
              return;
            }

            const status =
              approvalStatus === "Approved" ? "Reviewed" : "Rejected";

            await dispatch(approvedToReview(currentRequestId, status));

            // 🔥 Refresh the table instantly (NO PAGE RELOAD)
            await dispatch(loadRequestData());

            setUpdateModalOpen(false);
            setSuccessOpen(true);
          }}>
            <Typography variant="h6" mb={2}>Update Request</Typography>
            <Typography mb={2}>Request ID: {currentRequestId}</Typography>
            <TextField select
              fullWidth
              label="Select"
              value={approvalStatus}
              onChange={(e) => setApprovalStatus(e.target.value)}
              required
              disabled={(selectedRequestData?.request_status || "").toLowerCase() === "reviewed"}
            >
              <MenuItem value="Approved">Approved</MenuItem>
              <MenuItem value="Rejected">Rejected</MenuItem>
            </TextField>

            <Box display="flex" justifyContent="flex-end" mt={3}>
              <Button variant="outlined" onClick={() => setUpdateModalOpen(false)} sx={{ mr: 2 }} style={{
                borderColor: "#0d6efd",
                color: "#0d6efd",
                marginTop: "10px"
              }}>Cancel</Button>
              <Button variant="contained" style={{
                backgroundColor: "#0d6efd",
                color: "#ffffff",
                marginTop: "10px"
              }} type="submit">Submit</Button>
            </Box>
          </Box>
        </Modal>

        <Modal open={formDataModalOpen} onClose={() => setFormDataModalOpen(false)}>
          <Box sx={modalStyle}>
            <Typography variant="h6" mb={2}>Request Details</Typography>

            {selectedRequestData && (
              <Box className="row g-3">


                {responseData.length > 0 && (
                  <div className="col-md-12">
                    <Typography variant="subtitle1" mt={2} sx={{ fontWeight: "bold" }}>
                      Previous Responses:
                    </Typography>

                    {responseData.map((rsp) => (
                      <Box
                        key={rsp.response_id}
                        sx={{ border: "1px solid #ccc", borderRadius: "8px", p: 2, mt: 1 }}
                      >
                        <Typography><strong>Response Count:</strong> {rsp.response_count || "N/A"}</Typography>
                        <Typography><strong>Remarks:</strong> {rsp.remarks || "N/A"}</Typography>

                        {rsp.attachment_name && (
                          <Button
                            variant="text"
                            size="small"
                            // onClick={() => window.open(rsp.attachment_name, "_blank")}
                            onClick={() =>
                              window.open(
                                `https://gfcb8ed8eb8355a.../response_data/download?response_id=${rsp.response_id}`,
                                "_blank"
                              )
                            }
                          >
                            📎 Download Attachment
                          </Button>
                        )}

                        <Typography sx={{ fontSize: "12px", mt: 1, color: "gray" }}>
                          <strong>Date:</strong> {new Date(rsp.created_date).toLocaleString()}
                        </Typography>
                      </Box>
                    ))}
                  </div>
                )}

                <div className="col-md-6">
                  <TextField fullWidth label="Company" value={selectedRequestData.company_name} InputProps={{ readOnly: true }} sx={readOnlyStyle} />
                </div>

                <div className="col-md-6">
                  <TextField fullWidth label={userRole?.toLowerCase() === "b2buser" ? "Response Type" : "Request Type"} value={selectedRequestData.request_type} InputProps={{ readOnly: true }} sx={readOnlyStyle} />
                </div>


                <div className="col-md-6">
                  <TextField fullWidth label="Title" value={selectedRequestData.title} InputProps={{ readOnly: true }} sx={readOnlyStyle} />
                </div>
                
                <div className="col-md-6">
                  <TextField fullWidth type="number" label="Response Count" value={responseCount} onChange={(e) => setResponseCount(e.target.value)} />
                </div>

                <div className="col-md-6">
                  <TextField fullWidth label="Criteria" value={selectedRequestData.criteria} InputProps={{ readOnly: true }} sx={readOnlyStyle} />
                </div>

                <div className="col-md-6">
                  <TextField fullWidth label="Geography" value={selectedRequestData.geography} InputProps={{ readOnly: true }} sx={readOnlyStyle} />
                </div>

                <div className="col-md-6">
                  <label htmlFor="fileInput">Select File:</label>
                  <input type="file" id="fileInput" onChange={(e) => setSelectedFile(e.target.files[0])} />
                </div>

                <div className="col-md-12">
                  <TextField fullWidth multiline rows={3} label="Remarks" value={newRemark} onChange={(e) => setNewRemark(e.target.value)} />
                </div>

                <Box display="flex" justifyContent="flex-end" mt={3} gap={2}>
                  <Button variant="outlined" onClick={() => setFormDataModalOpen(false)} style={{ marginTop: "10px" }}>Cancel</Button>

                  <Button
                    style={{ marginTop: "10px" }}
                    variant="contained"
                    onClick={async () => {
                      if (!selectedRequestData) return;

                      setFormDataModalOpen(false);

                      try {
                        let uploadedFileName = null;

                        if (selectedFile) {
                          const isUploadSuccess = await uploadAttachment(
                            selectedFile,
                            selectedRequestData.request_id,
                            selectedRequestData.request_for
                          );

                          if (!isUploadSuccess) {
                            // toast.error("File upload failed!");
                            return;
                          }

                          uploadedFileName = selectedFile.name;

                          selectedRequestData.request_status = "completed";
                        }

                        const payload = {
                          request_id: selectedRequestData.request_id,
                          request_for: selectedRequestData.request_for,
                          response_count: responseCount,
                          remarks: newRemark,
                          user_id: currentUserId,
                          user_role: userRole,
                          attachment: uploadedFileName,
                        };

                        const requestOptions = {
                          method: "POST",
                          mode: "cors",
                          headers: {
                            "Content-Type": "application/json",
                            ...HeaderAuthentication.postAuthOfLeadMerge,
                          },
                          body: JSON.stringify(payload),
                        };

                        const result = await dispatch(postRaiseRequestData(requestOptions));

                        if (result) {
                          setSuccessOpen(true);
                          dispatch(loadRequestData());
                        }
                      } catch (err) {
                        console.error(err);
                        toast.error("Something went wrong");
                      }
                    }}
                  >
                    Submit
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Modal>

        <Modal
          open={quoteDataModal}
          onClose={() => setquoteDataModal(false)}
          className="requestModal"
        >
          <Box sx={modalStyle}>
            <Typography variant="h6" mb={2}>Quote Details</Typography>

            {selectedRequestData && (
              <Box className="row g-3">

                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Count"
                    value={quoteForm.counts}
                    onChange={(e) =>
                      setQuoteForm({ ...quoteForm, counts: e.target.value })
                    }
                  />
                </div>

                <div className="col-md-6">
                  <TextField
                    fullWidth
                    label="Amount"
                    value={quoteForm.amount}
                    onChange={(e) =>
                      setQuoteForm({ ...quoteForm, amount: e.target.value })
                    }
                  />
                </div>

              </Box>
            )}

            <Box display="flex" justifyContent="flex-end" gap={2} mt={3}>
              
              {/* ✅ CLOSE BUTTON */}
              <Button
                onClick={() => setquoteDataModal(false)}
                variant="outlined"
                style={{
                  borderColor: "#0d6efd",
                  color: "#0d6efd",
                  marginTop: "10px"
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  console.log("Submitted Quote:", {
                    request_id: selectedRequestData.request_id,
                    ...quoteForm
                  });

                  // 👉 Call API here if needed
                  // dispatch(submitQuoteAction(selectedRequestData.request_id, quoteForm));

                  setquoteDataModal(false);
                }}
                style={{
                  background: "#0d6efd",
                  color: "#fff",
                  marginTop: "10px"
                }}
              >
                Submit
              </Button>
            </Box>
          </Box>
        </Modal>
        <Snackbar open={successOpen} autoHideDuration={3000} onClose={() => setSuccessOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
          <Alert onClose={() => setSuccessOpen(false)} severity="success" sx={{ width: "100%" }}>Request submitted successfully!</Alert>
        </Snackbar>
      </div>
    </div>
  );

  return hideLayout ? content : (
    <AppLayout>
      {content}
      <Footer />
    </AppLayout>
  );
};

export default RaiseRequest;
